import axios from 'axios';
function obtenerSolicitudes() {
  return axios.get("/obtener_solicitudes")
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function archivarSolicitud(solicitud) {
  return axios.post("/archivar_solicitud", solicitud)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function eliminarSolicitud(solicitudId) {
  return axios.post("/eliminar_solicitud", { id: solicitudId })
    .then((response) => {
      if (response.data && response.data.status === "success") {
        return response.data;
      } else {
        throw new Error(response.data.message || "Error desconocido");
      }
    })
    .catch((error) => {
      console.error("Error eliminando solicitud:", error);
      throw error;
    });
}
export {obtenerSolicitudes, archivarSolicitud, eliminarSolicitud};
